<script lang="ts" setup>
import { computed, ref, showErrorMsg } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { gatherCodeLevel } from '~/api/user';
import { ProfileService } from '~/services/profile.service';
import { ZoneService } from '~/services/zone.service';
import {
  CPP_PROGRAM_LEVEL_OPTIONS,
  PYTHON_PROGRAM_LEVEL_OPTIONS,
} from '~/utils/constant';

const service = useService(ProfileService);
const zoneService = useService(ZoneService);

const title = computed(() => {
  return zoneService.zone === 'cpp'
    ? '你当前的C++水平是？'
    : '你当前的Python水平是？';
});

const options = computed(() => {
  return zoneService.zone === 'cpp'
    ? CPP_PROGRAM_LEVEL_OPTIONS
    : PYTHON_PROGRAM_LEVEL_OPTIONS;
});

const loading = ref(false);
const closable = ref(false);
const selected = ref<number>();

function handleSelectLevel(v: number) {
  selected.value = v;
}

function handleSubmit() {
  loading.value = true;
  gatherCodeLevel({ codeLevel: selected.value as number })
    .then(() => {
      service.setVisible(false);
    })
    .catch((e) => {
      showErrorMsg(e);
      closable.value = true;
    })
    .finally(() => {
      loading.value = false;
    });
}
</script>

<template>
  <a-modal
    v-model:open="service.programLevelVisible"
    :width="380"
    :footer="null"
    :closable="closable"
    :mask-closable="false"
    :destroy-on-close="true"
    :body-style="{ padding: '24px 40px 32px' }"
    :centered="true"
  >
    <h2 class="mb-6 text-center text-base font-bold text-font1">{{ title }}</h2>

    <div class="grid grid-cols-2 gap-5">
      <div
        v-for="item in options"
        :key="item.value"
        class="h-12 w-full cursor-pointer rounded-sm border border-[#D9D9D9] flex-center hover:border-[#C1C1C1]"
        :class="{ '!border-primary': item.value === selected }"
        @click="handleSelectLevel(item.value)"
      >
        {{ item.label }}
      </div>
    </div>

    <div class="flex-center">
      <a-button
        :disabled="!selected"
        :loading="loading"
        type="primary"
        size="large"
        class="disabled-opacity mt-6 w-40"
        @click="handleSubmit"
        >确定</a-button
      >
    </div>
  </a-modal>
</template>

<style scoped></style>
